






import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";

@Component({
    name: "CustomerCare"
})
export default class extends mixins(CommonMixin) {
}
